function Logout()
{
    localStorage.removeItem('authData');
    window.location.reload();
}

export default Logout;